<template>
  <div
    data-testid="path-selector"
    class="flex flex-wrap space-y-1 pb-2 font-inter text-xs font-medium text-gray-100"
  >
    <div class="mt-1 flex items-center">
      <button
        :class="[
          actualPath === undefined
            ? 'text-gray-50'
            : 'cursor-pointer hover:text-gray-100',
        ]"
        class="rounded-md bg-gray-600 px-[10px] py-[6px] font-inter text-xs font-medium leading-5 text-gray-100"
        :disabled="links.length < 1"
        @click="$emit('chooseFolder', undefined)"
      >
        {{ $t("file_manager.root") }}
      </button>
      <span
        v-if="folders[0] && folders[0].length > 0"
        class="inline-grid h-[20px] w-[20px] items-center justify-center"
      >
        <font-awesome-icon :icon="['fas', 'angle-right']" />
      </span>
    </div>
    <div v-for="(link, index) in links" :key="index" class="flex items-center">
      <TDropdown ref="dropdownFolders">
        <template #selected-content>
          <p style="min-width: 70px; text-align: left">
            {{ link.name }}
          </p>
        </template>

        <template #content>
          <ul>
            <VueCustomScrollbar
              style="position: relative; margin: auto"
              :style="{ height: calculatedHeightFolders(index) + 'px' }"
              :settings="{ wheelPropagation: false }"
            >
              <li
                v-for="(folder, k) in folders[index]"
                :key="k"
                @click="
                  $emit('chooseFolder', folder.id);
                  closeDrop(index - 1);
                "
              >
                <p>
                  {{ folder.name }}
                </p>
              </li>
            </VueCustomScrollbar>
          </ul>
        </template>
      </TDropdown>
      <span
        v-if="
          index !== links.length - 1 ||
          (folders[index + 1] && folders[index + 1].length > 0)
        "
        class="inline-grid h-[20px] w-[20px] items-center justify-center"
      >
        <font-awesome-icon :icon="['fas', 'angle-right']" />
      </span>
    </div>
    <TDropdown
      v-if="folders[links.length] && folders[links.length].length > 0"
      ref="dropdownFoldersLast"
    >
      <template #selected-content>
        <p
          class="text-left"
          :class="{
            'w-[70px]': dropdownFoldersLast?.opened,
          }"
        >
          ...
        </p>
      </template>

      <template #content>
        <ul>
          <VueCustomScrollbar
            :style="{
              height: calculatedHeightFolders(links.length) + 'px',
            }"
            :settings="{ wheelPropagation: false }"
          >
            <li
              v-for="(folder, k) in folders[links.length]"
              :key="k"
              @click="$emit('chooseFolder', folder.id)"
            >
              <p>
                {{ folder.name }}
              </p>
            </li>
          </VueCustomScrollbar>
        </ul>
      </template>
    </TDropdown>
  </div>
</template>

<script setup lang="ts">
  import { ISavedBlockApi } from "@/schemas/savedBlock/savedBlockApiSchema";
  import { TDropdown } from "@topol/twig-ui";
  import { PerfectScrollbar as VueCustomScrollbar } from "vue3-perfect-scrollbar";
  import { ref } from "vue";

  interface Link {
    name: string;
    id: number;
  }

  const props = defineProps<{
    links: Array<Link>;
    folders: Array<ISavedBlockApi[]>;
    actualPath: number | undefined;
  }>();

  defineEmits(["chooseFolder"]);

  const dropdownFolders = ref();
  const dropdownFoldersLast = ref();

  function calculatedHeightFolders(i: number) {
    if (props.folders[i]) {
      const height = props.folders[i].length * 32;
      if (height > 125) {
        return 125;
      }
      return height;
    }
    return 125;
  }

  function closeDrop(index: number) {
    if (!dropdownFolders.value || !dropdownFolders.value[index]) return;
    dropdownFolders.value[index].opened = false;
  }
</script>
